import React from 'react';
import { Link, useMatch } from "../../../vendor/router-ROUTER_TARGET";

import IconHome from './svg/IconHome';

import { useSelector } from "react-redux";

function HomeMenu() {
  const storeRoute = useSelector(state => state.storeRoute);
  let match = useMatch({ path: '/home', end: false });
  let matchTwo = useMatch({ path: '/', end: true });
  const isSelected = (match || matchTwo);
  const setHistory = () => {
    storeRoute.goTo('/home');
  }

  return (
    <div className={`menu-left-container ${isSelected && `selected`} `} >
      <Link id={`link-ref-rp`} onClick={setHistory} style={{textDecoration: `none`}} to={'/home'}>
        <div id={`ref-rp`} className={`flexRow align top-menu-container ${isSelected && `selected`}`}>
          <IconHome />
          <span className={`type-regular fz14`}>Discover</span>
        </div>
      </Link>
    </div>     
  )
}

export default HomeMenu;
